import { render, staticRenderFns } from "./MenuParcerias.vue?vue&type=template&id=164b9fc0&scoped=true"
import script from "./MenuParcerias.vue?vue&type=script&lang=js"
export * from "./MenuParcerias.vue?vue&type=script&lang=js"
import style0 from "./MenuParcerias.vue?vue&type=style&index=0&id=164b9fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164b9fc0",
  null
  
)

export default component.exports